import * as React from 'react';
import MuiAvatar from '@mui/material/Avatar';
import MuiListItemAvatar from '@mui/material/ListItemAvatar';
import MenuItem from '@mui/material/MenuItem';
import ListItemText from '@mui/material/ListItemText';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListSubheader from '@mui/material/ListSubheader';
import Select, { selectClasses } from '@mui/material/Select';
import Divider from '@mui/material/Divider';
import { styled } from '@mui/material/styles';
import AddRoundedIcon from '@mui/icons-material/AddRounded';
import DevicesRoundedIcon from '@mui/icons-material/DevicesRounded';
import SmartphoneRoundedIcon from '@mui/icons-material/SmartphoneRounded';
import ConstructionRoundedIcon from '@mui/icons-material/ConstructionRounded';

const Avatar = styled(MuiAvatar)(({ theme }) => ({
  width: 28,
  height: 28,
  backgroundColor: theme.palette.background.paper,
  color: theme.palette.text.secondary,
  border: `1px solid ${theme.palette.divider}`,
}));

const ListItemAvatar = styled(MuiListItemAvatar)({
  minWidth: 0,
  marginRight: 12,
});

export default function SelectContent(props) {
  const { profile, setSucursalId, sucursal_id } = props;
  const [company, setCompany] = React.useState(sucursal_id);

  const handleChange = event => {
    setCompany(event.target.value);
  };

  return (
    <Select
      labelId="company-select"
      id="company-simple-select"
      value={company}
      onChange={handleChange}
      displayEmpty
      inputProps={{ 'aria-label': 'Select company' }}
      fullWidth
      sx={{
        maxHeight: 56,
        width: 270,
        '&.MuiList-root': {
          p: '8px',
        },
        [`& .${selectClasses.select}`]: {
          display: 'flex',
          alignItems: 'center',
          gap: '2px',
          pl: 1,
        },
      }}>
      <ListSubheader sx={{ pt: 0 }}>Producción</ListSubheader>
      {profile.sucursales.filter(sucursal => sucursal.sucursal_is_prod === true).map((sucursal, index) => (
      <MenuItem value={sucursal.sucursal_id} key={sucursal.sucursal_id} onClick={() => setSucursalId(sucursal.sucursal_id)}>
        <ListItemAvatar>
          <Avatar alt={profile.tenant_name}>
            <SmartphoneRoundedIcon sx={{ fontSize: '1rem' }} />
          </Avatar>
        </ListItemAvatar>
        <ListItemText primary={profile.tenant_name} secondary={sucursal.sucursal_name} />
      </MenuItem>
      ))}
      
      <ListSubheader>Desarrollo</ListSubheader>
      {profile.sucursales.filter(sucursal => sucursal.sucursal_is_prod === false).map((sucursal, index) => (
      <MenuItem value={sucursal.sucursal_id} key={sucursal.sucursal_id} onClick={() => setSucursalId(sucursal.sucursal_id)}>
        <ListItemAvatar>
          <Avatar alt={profile.tenant_name}>
            <SmartphoneRoundedIcon sx={{ fontSize: '1rem' }} />
          </Avatar>
        </ListItemAvatar>
        <ListItemText primary={profile.tenant_name} secondary={sucursal.sucursal_name} />
      </MenuItem>
      ))}
    </Select>
  );
}
